export const routes = {
  home: '/',
  horseClub: '/horseclub',
  services: '/services',
  news: '/news',
  community: '/community',
  partners: '/partners',
  support: '/support',
  myInfo: '/myinfo',
  intro: '/intro',
  kraCitizenEvent: '/event/kracitizen',
};

export const partnerManagerUrl =
  process.env.REACT_APP_MARLTA_MANAGER_INTRO_URL || 'https://manager.marlta.com/#/intro';

export const navItems = [
  { id: 'home', path: routes.home, label: '홈', icon: 'home', authRequired: false },
  {
    id: 'horseClub',
    path: routes.horseClub,
    label: '승마장검색',
    icon: 'search',
    authRequired: false,
  },
  { id: 'news', path: routes.news, label: '승마뉴스', icon: 'notice', authRequired: false },
  {
    id: 'community',
    path: routes.community,
    label: '커뮤니티',
    icon: 'community',
    authRequired: false,
  },
  { id: 'myInfo', path: routes.myInfo, label: '내정보', icon: 'user', authRequired: true },
];

export const mobileNavItems = navItems;

export const utilityRouteItems = [
  { id: 'services', path: routes.services, label: '서비스', authRequired: false },
  { id: 'partners', path: routes.partners, label: '파트너스', authRequired: false },
  { id: 'support', path: routes.support, label: '고객센터', authRequired: false },
];

export const routeMap = [...navItems, ...utilityRouteItems].reduce(
  (map, item) => ({
    ...map,
    [item.path]: item,
  }),
  {},
);

export const routeAliases = {
  '/notice': routes.news,
  '/my': routes.myInfo,
};

export const supportedRoutes = new Set([
  ...navItems.map((item) => item.path),
  ...utilityRouteItems.map((item) => item.path),
  routes.intro,
  routes.kraCitizenEvent,
]);
